module.exports = __webpack_public_path__ + "static/img/13.a402080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/13.png
// module id = A34k
// module chunks = 13